import NCNotificationContainer from './NCNotification.container';
import NCNotification from './NCNotification';
export default NCNotificationContainer(NCNotification);
